export default Object.freeze({
  upcoming: 'upcoming',
  past: 'past',
  cancelled: 'cancelled',
  all: 'all',
  approvalRequired: 'approvalRequired',
})
